var logoYoutube = "https://shopfront-cdn.tekoapis.com/static/2d3d889a92325278.svg";

export { logoYoutube as default };
